import { selector } from 'recoil';

import uidAtom from '~/recoil/atom/uid';
import emailAtom from '~/recoil/atom/email';
import couponAtom from '~/recoil/atom/coupon';
import ordersAtom from '~/recoil/atom/orders';
import taxInfoAtom from '~/recoil/atom/taxInfo';
import taxTypeAtom from '~/recoil/atom/taxType';
import cartTypeAtom from '~/recoil/atom/cartType';
import orderTypeAtom from '~/recoil/atom/orderType';
import cartStatusAtom from '~/recoil/atom/cartStatus';
import pickMealAtAtom from '~/recoil/atom/pickMealAt';
import campaignIdAtom from '~/recoil/atom/campaignId';
import pickMealEndAtom from '~/recoil/atom/pickMealEnd';
import paymentTypeAtom from '~/recoil/atom/paymentType';
import remotePickMealPointAtom from '~/recoil/atom/remotePickMealPoint';
import { PlatformCart } from '~/types/cart';
import globalEnterpriseGroupBuyAtom from '../atom/enterpriseGroupBuy/globalEnterpriseGroupBuyAtom';
import enterpriseGroupBuyOrdersAtom from '../atom/enterpriseGroupBuy/enterpriseGroupBuyOrders';

const cart = selector<PlatformCart>({
  key: 'cart',
  get: ({ get }) => {
    const uid = get(uidAtom);
    const email = get(emailAtom);

    const cartType = get(cartTypeAtom);
    const coupon = get(couponAtom);
    const orders = get(ordersAtom);
    const taxInfo = get(taxInfoAtom);
    const taxType = get(taxTypeAtom);
    const status = get(cartStatusAtom);
    const orderType = get(orderTypeAtom);
    const campaignId = get(campaignIdAtom);
    const pickMealAt = get(pickMealAtAtom);
    const pickMealEnd = get(pickMealEndAtom);
    const paymentType = get(paymentTypeAtom);
    const pickMealPoint = get(remotePickMealPointAtom);

    const enterpriseGroupBuyData = get(globalEnterpriseGroupBuyAtom);
    const enterpriseGroupBuyOrders = get(enterpriseGroupBuyOrdersAtom);

    if (!!enterpriseGroupBuyData?.data) {
      const { id } = enterpriseGroupBuyData?.data;
      const cartId = `enterprise_group_buy_${id}_${uid}`;
      return {
        orders: enterpriseGroupBuyOrders,
        enterpriseGroupBuyId: id,
        uid,
        email: '',
        coupon: null,
        campaignId: '',
        pickMealPoint: null,
        cartId,
        orderType,
        taxInfo,
        taxType,
        status,
        cartType,
        pickMealAt,
        pickMealEnd,
        paymentType,
      };
    }

    return {
      uid,
      email,
      orders,
      status,
      coupon,
      taxInfo,
      taxType,
      cartType,
      orderType,
      campaignId,
      pickMealAt,
      pickMealEnd,
      paymentType,
      pickMealPoint,
    } as PlatformCart;
  },
});

export default cart;
